import { createBrowserRouter, Navigate } from 'react-router'
import { AppLayout } from '@/components/layout/app-layout'
import { ProtectedRoute } from '@/lib/protected-route'
import { AnalyticsPage } from '@/pages/analytics'
import { ApiKeysPage } from '@/pages/api-keys'
import { AudienceDetailPage } from '@/pages/audiences/audience-detail'
import { AudiencesListPage } from '@/pages/audiences/audiences-list'
import { BillingPage } from '@/pages/billing'
import { CampaignDetailPage } from '@/pages/campaigns/campaign-detail'
import { CampaignWizardPage } from '@/pages/campaigns/campaign-wizard'
import { CampaignsListPage } from '@/pages/campaigns/campaigns-list'
import { ChoosePlanPage } from '@/pages/choose-plan'
import { DomainListPage } from '@/pages/domains/domain-list'
import { EmailDetailPage } from '@/pages/emails/email-detail'
import { EmailListPage } from '@/pages/emails/email-list'
import { IPsPage } from '@/pages/ips'
import { LoginPage } from '@/pages/login'
import { NotificationsPage } from '@/pages/notifications'
import { OnboardingPage } from '@/pages/onboarding'
import { SetupApiKeyPage } from '@/pages/onboarding/setup-api-key'
import { SetupDomainPage } from '@/pages/onboarding/setup-domain'
import { OverviewPage } from '@/pages/overview'
import { SettingsPage } from '@/pages/settings'
import { SignupPage } from '@/pages/signup'
import { SuppressionsPage } from '@/pages/suppressions'
import { TemplateEditorPage } from '@/pages/template-editor'
import { TemplateListPage } from '@/pages/templates-list'
import { WebhooksPage } from '@/pages/webhooks'
import { WordPressPage } from '@/pages/wordpress'
import { WordPressSetupPage } from '@/pages/wordpress-setup'
import { SetupGuidePage } from '@/pages/wordpress-setup/setup-guide'

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/choose-plan',
    element: (
      <ProtectedRoute>
        <ChoosePlanPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/onboarding',
    element: <Navigate to="/" replace />,
  },
  {
    path: '/onboarding/domain',
    element: <Navigate to="/" replace />,
  },
  {
    path: '/onboarding/api-key',
    element: <Navigate to="/" replace />,
  },
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <OverviewPage /> },
      { path: 'emails', element: <EmailListPage /> },
      { path: 'emails/:id', element: <EmailDetailPage /> },
      { path: 'audiences', element: <AudiencesListPage /> },
      { path: 'audiences/:id', element: <AudienceDetailPage /> },
      { path: 'campaigns', element: <CampaignsListPage /> },
      { path: 'campaigns/new', element: <CampaignWizardPage /> },
      { path: 'campaigns/:id', element: <CampaignDetailPage /> },
      { path: 'campaigns/:id/edit', element: <CampaignWizardPage /> },
      { path: 'domains', element: <DomainListPage /> },
      { path: 'analytics', element: <AnalyticsPage /> },
      { path: 'templates', element: <TemplateListPage /> },
      { path: 'templates/new', element: <TemplateEditorPage /> },
      { path: 'templates/:id', element: <TemplateEditorPage /> },
      { path: 'api-keys', element: <ApiKeysPage /> },
      { path: 'webhooks', element: <WebhooksPage /> },
      { path: 'wordpress', element: <WordPressPage /> },
      { path: 'wordpress/setup', element: <WordPressSetupPage /> },
      { path: 'wordpress/setup/guide', element: <SetupGuidePage /> },
      { path: 'ips', element: <IPsPage /> },
      { path: 'suppressions', element: <SuppressionsPage /> },
      { path: 'notifications', element: <NotificationsPage /> },
      { path: 'billing', element: <BillingPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])
